/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Event } from '../../models/event';
import { PostEventRequest } from '../../models/post-event-request';

export interface PostEvent$Params {
  roomId: string;
      body: PostEventRequest
}

export function postEvent(http: HttpClient, rootUrl: string, params: PostEvent$Params, context?: HttpContext): Observable<StrictHttpResponse<Event>> {
  const rb = new RequestBuilder(rootUrl, postEvent.PATH, 'post');
  if (params) {
    rb.path('roomId', params.roomId, {"style":"simple"});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Event>;
    })
  );
}

postEvent.PATH = '/chat/v0/rooms/{roomId}/events';
